/* eslint-disable no-param-reassign */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishListThunk, removeFromWishListThunk } from 'redux/Reducers/WishList/WishListSlice';

import { WishListContext } from 'Context/Wishlist';

import MediaQuery from 'react-responsive';
import {
  Col as ColAntd,
  Row
} from 'antd';

// DS
import {
  Col,
  VertCollapse,
  VertContainer,
  VertModal,
  VertSkeleton,
  VertTypography,
  notification,
} from '@vertem-core/vertice-ds';

// COMPONENTS
import AgroInsuranceQuotationFormModal from 'components/Product/QuotationModal/AgroInsuranceQuotationFormModal';
import ProductDetailBlock from 'components/Product/ProductDetailBlock/ProductDetailBlock';
import ProductHeader from 'components/Product/ProductHeader/ProductHeader';
import ProductImage from 'components/Product/ProductImage/ProductImage';
import ShowCaseAutomate from 'components/ShowCaseAutomate/ShowCaseAutomate';

// CONSTANTS
import { ShowcaseDisplayAreaEnum } from 'Constants/ShowCaseConstants';

// API
import PipeProvider from 'Services/Providers/PipeProvider';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';

// STYLES
import 'Assets/styles/default/pages/product/ProductStyles.less';

// UTILS
import generateUUID from 'Utils/generateUUID';
import CepProvider from '../../Shared/common/components/CepProvider';
import { getObjectByKey } from 'Utils/getObjectByKey';
import { formatReal } from 'Utils/format'

// MOCKS
import { productPageMocks } from './mocks';
import SyngentaQuotationFormModal from 'components/Product/QuotationModal/SyngentaQuotationFormModal';
import { addDimensionsAddCartGTM, addDimensionsProductGTM } from 'Shared/dataLayer/dataLayer';
import RelatedProductsCard from 'components/Product/RelatedProductsCard/RelatedProductsCard';
import ModalRelatedProductDetails from 'components/Product/ModalRelatedProductDetails/ModalRelatedProductDetails';
import { genericSupplierEndpoint } from 'Services/Apis/clients';
import { Typography } from 'antd';
import DefaultQuotationFormModal from 'components/Product/QuotationModal/DefaultQuotationFormModal';
import { QUOTATION_FORM_TYPE } from 'Constants/QuotationFormConstants';
import { useRating } from "../../components/RatingProducts/Provider";
import useGA from "Utils/Ga";
import * as productService from '../../Services/Apis/Products/index';

// PRODUCT PAGE
const ProductPage = () => {
  /* Hooks */
  // @ts-ignore
  const { eventGa } = useGA()
  const { ratingList, getRatingBySku, isEnabled: ratingIsEnabled } = useRating()
  const { callApi } = usePipeContext();
  const refAboutProduct = useRef(null);
  const { sku } = useParams();
  const { simpleWishList, updateSimpleWishList } = useContext(WishListContext);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const availabilityItems = useSelector(({ Availability }) => Availability);
  const userProfile = useSelector((state) => state?.oidc?.user?.profile);
  const Catalog = useSelector(({ Catalog: data }) => data)
  const User = useSelector((state) => state?.oidc?.user);
  const Cart = useSelector(({ Cart }) => Cart);
  const dataProduct = useSelector(({ Products }) => Products);
  const dataProductGeneric = useSelector(({ ProductsGeneric }) => ProductsGeneric);
  const dataProductRelated = useSelector(({ ProductsRelated }) => ProductsRelated);
  const Participants = useSelector(({ Participants }) => Participants);
  const pointsPlusCash = useSelector(({ PointsPlusCash }) => PointsPlusCash);
  const RatingProduct = useSelector(({ RatingProduct }) => RatingProduct);
  const RatingStore = useSelector(({ RatingStore }) => RatingStore);

  /* States */
  const [productRelatedSelected, setProductRelatedSelected] = useState(null);
  const [product, setProduct] = useState(null);
  const [originalId, setOriginalId] = useState('');
  const [productAboutItems, setProductAboutItems] = useState([]);
  const [skuSelectedDetails, setSkuSelectedDetails] = useState(null);
  const [isOpenInfoModal, setIsOpenInfoModal] = useState(false);
  const [rating, setRating] = useState({ store: null, product: null });
  const [isOpenQuotationModal, setIsOpenQuotationModal] = useState(false);
  const [isOpenInfoRelatedModal, setIsOpenInfoRelatedModal] = useState(false);
  const [productRelatedDetailsId, setProductRelatedDetailsId] = useState("");
  const [productHaveRelatedItems, setProductHaveRelatedItems] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [availabilityBySku, setAvailabilityBySku] = useState(null);
  const [verifyHasInventory, setVerifyHasInventory] = useState();

  /* Vars */
  const email = Participants?.email?.value || '';
  const isProductInWishList = simpleWishList.get(sku);
  const pointsPlusCashBySku = getObjectByKey(pointsPlusCash, sku);

  /* Handlers */
  const infoModalHandler = () => {
    setIsOpenInfoModal(!isOpenInfoModal);
  };

  const handleAddToCart = ({ redirectToCart }) => {

    var skuPayload = sku;
    var vendorIdPayload = product.vendor.id;

    if (productHaveRelatedItems) {
      var productSelected = relatedProducts.find(related => related.marketplaceSku == sku);
      if (!productSelected) {
        notification.error({ message: 'Não foi possível recuperar o Sku do Marketplace!' })
        return;
      }
      skuPayload = productSelected.marketplaceSku;
      vendorIdPayload = productSelected.vendor.integrationId;
    }
    callApi({
      symbol: 'ADD_ITEM_TO_CART',
      alias: generateUUID(),
      payload: {
        email,
        quantity: skuSelectedDetails?.minimumPurchase || 1,
        sku: skuPayload,
        vendorId: vendorIdPayload,
        redirectToCart
      },
    });
  };

  const handleToggleWishList = async () => {
    try {
      isProductInWishList
        ? await dispatch(removeFromWishListThunk(sku)).unwrap()
        : await dispatch(addToWishListThunk(sku)).unwrap();

      updateSimpleWishList();
    } catch (err) {
      console.log(err);

      notification.error({
        message: "Houve um erro ao favoritar produto, tente novamente mais tarde.",
      });
    }
  };

  /* Utils */
  const getRatingStore = () => {
    callApi({
      symbol: 'FETCH_RATING_STORE',
      alias: generateUUID(),
      payload: {
        vendorId: product.vendor.id,
      },
    });
  };

  const getRatingProduct = () => {
    callApi({
      symbol: 'FETCH_RATING_PRODUCT',
      alias: generateUUID(),
      payload: {
        sku,
      },
    });
  };
  /* Lifecycles */

  const clearDataRelatedProduct = () => {
    setRelatedProducts([]);
    setProductRelatedSelected(null);
    setIsOpenInfoRelatedModal(false);
    setProductRelatedDetailsId("");
    setProductHaveRelatedItems(false);
    productService.resetRelatedProducts();
  }

  const handleQuotationModal = (val) => {
    setIsOpenQuotationModal(val);
  };

  const handleProductDetail = (sku) => {
    setProductRelatedDetailsId(sku);
  }

  const handleClearSelectedVendor = () => {
    setProductRelatedSelected(null);
  };

  const handleGetRatings = () => {
    getRatingStore();
    getRatingProduct();
  }

  const handleGetAvailability = () => {
    if (!product.skus?.filter(({ sku: s }) => s === sku).length)
      return;

    callApi({
      symbol: 'FETCH_AVAILABILITY',
      alias: `${generateUUID()}-${sku}`,
      payload: {
        force: true,
        sku,
        originalId: product.skus?.filter(({ sku: s }) => s === sku)[0].originalId,
        vendorId: product.vendor.id,
        callback: (e) => {

          if (e === null) return;
          const { available, cash, discountRate, pointsCash } = e.data[0];
          setAvailabilityBySku({
            isAvailable: available,
            isLoaded: true,
            isLoading: false,
            isPriceUpdated: true,
            price: {
              cash,
              pointsCash,
              ...cash,
              discountRate,
            }
          })
        }
      },
    });
  }

  useEffect(() => {
    const ratingStoreBySku = getObjectByKey(RatingStore, product?.vendor.id);
    if (ratingStoreBySku) {
      const { average, totalCount } = ratingStoreBySku;
      setRating((state) => ({ ...state, store: { average, totalCount } }));
    }
  }, [RatingStore]);

  useEffect(() => {
    const ratingProducteBySku = getObjectByKey(RatingProduct, sku);
    if (ratingProducteBySku) {
      const { average, totalCount } = ratingProducteBySku;
      setRating((state) => ({ ...state, product: { average, totalCount } }));
    }
  }, [RatingProduct]);

  const handleSetAvailabilityBySku = useCallback(() => {
    setAvailabilityBySku(getObjectByKey(availabilityItems, sku))
  }, [availabilityItems, sku])

  useEffect(() => {
    handleSetAvailabilityBySku()
  }, [availabilityItems, handleSetAvailabilityBySku]);

  const getGenericSupplierOfProductByOriginalId = async (originalId) => {
    const headers = {
      'Content-Type': 'application/json',
      profile: {
        'custom:campaign_id': userProfile['custom:campaign_id'],
        'custom:catalog_id': userProfile['custom:catalog_id'],
        'custom:participant_id': userProfile['custom:participant_id'],
      },
      access_token: `Bearer ${User.access_token}`,
    }

    if (originalId?.includes("-PGS")) {
      return await genericSupplierEndpoint(headers).get(`/Product/Sku/${originalId}`)
    }
  }

  const renderLocations = (product) => {
    return product?.locations[0]?.name.toLowerCase() == "todos" ? (
      <p className="product-about-item">
        Disponível em todas as localidades
      </p>
    ) : (
      product?.locations?.map((location) => (
        <div style={{ padding: '8px' }}>
          <Typography.Text strong>{location.name}: </Typography.Text>
          <Typography.Text>
            {location.cities.map((city) => (
              city.name + ', '
            )).join('').replace(/,([^,]*)$/, ';$1')}
          </Typography.Text>
        </div>
      ))
    )
  }

  const createLocationFeature = ({ newProduct }) => {
    return newProduct?.locations?.length ? [
      {
        label: 'LOCALIDADES',
        key: 'location',
        children: (
          <>
            {renderLocations(newProduct)}
          </>
        )
      }
    ] : null;
  }

  const idIsPGS = (id) => {

    if (!id)
      return false;

    return id.toUpperCase().includes("-PGS");
  }

  const handleFeatures = () => {

    let features = [];
    if (product?.features) {
      features = Object.entries(
        product.features.reduce((reformatedFeatures, elementoAtual) => {
          if (!reformatedFeatures[elementoAtual.type]) {
            reformatedFeatures[elementoAtual.type] = [];
          }
          reformatedFeatures[elementoAtual.type].push({
            name: elementoAtual.name,
            value: elementoAtual.value,
          });
          return reformatedFeatures;
        }, [])
      ).map(([key, value]) => {
        return {
          label: key,
          children: value.map((item) => (
            <p className="product-about-item">
              <span>{item.name}:</span> {item.value}
            </p>
          )),
        };
      });
      if (product.description) {
        features = [
          {
            label: 'DESCRIÇÃO',
            children: (
              <p
                className="product-about-item"
                dangerouslySetInnerHTML={{ __html: product.description }}
              />
            ),
          },
          ...features,
        ];
      }
    }
    productAboutItems.push(...features);
  }

  const handleLocation = async (sku) => {

    await getGenericSupplierOfProductByOriginalId(sku).then(res => {
      const locationFeatures = createLocationFeature({ newProduct: res?.data })
      if (locationFeatures && locationFeatures.length) {
        var listFeatures = productAboutItems.filter(item => item.key != 'location');
        listFeatures.push(...locationFeatures);
        setProductAboutItems(listFeatures);
      }
    }).catch(() => {
      console.log('Não foi possível encontrar localidades para esse produto.')
    })
  }

  const fetchProductsRelated = (idRelated) => {
    if (idRelated) {
      callApi({
        symbol: 'FETCH_PRODUCTS_RELATED',
        alias: `FETCH_PRODUCTS_RELATED_${idRelated}_${Math.floor(Math.random() * 100000)}`,
        payload: {
          sku: idRelated
        },
      });
      return;
    }
    setProductHaveRelatedItems(false);
  }

  useEffect(() => {
    return () => {
      clearDataRelatedProduct();
    }
  }, []);

  useEffect(() => {
    clearDataRelatedProduct();
    if (idIsPGS(sku)) {
      callApi({
        symbol: 'FETCH_PRODUCTS_GENERIC',
        alias: `FETCH_PRODUCTS_GENERIC_${sku}_${Math.floor(Math.random() * 100000)}`,
        payload: {
          sku
        },
      });
    } else {
      callApi({
        symbol: 'FETCH_PRODUCTS',
        alias: `FETCH_PRODUCTS_${sku}_${Math.floor(Math.random() * 100000)}`,
        payload: { sku },
      });
    }
  }, [sku]);

  useEffect(() => {
    if (!product) return;

    handleGetRatings();
    handleFeatures();
    handleGetAvailability();
  }, [product, sku]);

  useEffect(() => {
    if (dataProductGeneric.isLoaded) {
      const productCached = dataProductGeneric.productsGeneric?.filter((p) => {
        var skuSelected = p.skus?.filter((s) => s.sku === sku)[0];
        skuSelected = { ...skuSelected, minimumPurchase: p.minimumPurchase };
        skuSelected && setSkuSelectedDetails(skuSelected);
        return skuSelected || false;
      });
      setProduct(productCached.find(product => product.id == sku));
    }
  }, [dataProductGeneric]);

  useEffect(() => {
    if (dataProduct.isLoaded) {
      const productCached = dataProduct.products?.filter((p) => {
        const skuSelected = p.skus?.filter((s) => s.sku === sku)[0];
        skuSelected && setSkuSelectedDetails(skuSelected);
        return skuSelected || false;
      });
      productCached[0] && setProduct(productCached[0]);
    }
  }, [dataProduct]);

  useEffect(() => {
    if (dataProduct.error) {
      clearDataRelatedProduct();
    }
  }, [dataProduct.error]);

  useEffect(() => {
    if (!dataProductRelated.isLoadingRelated && dataProductRelated.isSuccessRelated) {
      var list = [...dataProductRelated.productsRelated];
      setRelatedProducts(list);
      if (dataProductRelated.productsRelated.length) {
        setProductHaveRelatedItems(true);
      }
    }
  }, [dataProductRelated]);

  useEffect(() => {
    if (sku && product && availabilityBySku) {
      addDimensionsProductGTM(product, sku, availabilityBySku);
    }
  }, [availabilityBySku]);

  useEffect(() => {
    setAvailabilityBySku(getObjectByKey(availabilityItems, sku))
  }, [availabilityItems]);

  useEffect(() => {
    const ratingStoreBySku = getObjectByKey(RatingStore, product?.vendor.id);
    if (ratingStoreBySku) {
      const { average, totalCount } = ratingStoreBySku;
      setRating((state) => ({ ...state, store: { average, totalCount } }));
    }
  }, [RatingStore]);

  useEffect(() => {
    const ratingProducteBySku = getObjectByKey(RatingProduct, sku);
    if (ratingProducteBySku) {
      const { average, totalCount } = ratingProducteBySku;
      setRating((state) => ({ ...state, product: { average, totalCount } }));
    }
  }, [RatingProduct]);

  const verifyInventory = (originalId) => {
    getGenericSupplierOfProductByOriginalId(originalId).then(({ data }) => {
      setVerifyHasInventory(data)
    }).catch((err) => {
      console.log(err)
      return
    })
  }

  useEffect(() => {
    if (dataProductGeneric?.genericProduct) return;
  }, [dataProductGeneric])


  useEffect(() => {
    if (skuSelectedDetails) {
      var idRelated = "";
      if (idIsPGS(skuSelectedDetails.sku)) {
        idRelated = skuSelectedDetails.sku;
      }
      else if (idIsPGS(skuSelectedDetails.originalId)) {
        idRelated = skuSelectedDetails.originalId;
      }

      fetchProductsRelated(idRelated);
      handleLocation(idRelated ? idRelated : sku);
      verifyInventory(skuSelectedDetails.originalId);
    }
  }, [skuSelectedDetails]);

  useEffect(() => {
    if (Cart.itemAdded) {
      callApi({
        symbol: 'FETCH_CART',
        alias: generateUUID(),
      });
      if (sku && product && availabilityBySku) {
        addDimensionsAddCartGTM(product, sku, availabilityBySku, (skuSelectedDetails?.minimumPurchase || 1));
      }
      if (Cart.redirectToCart) navigate("/cart");
    }
  }, [Cart.itemAdded]);

  useEffect(() => {
    if (sku && product) {
      getRatingStore();
      getRatingProduct();
    }
  }, [product, sku]);

  useEffect(() => {
    if (ratingList && !ratingList[sku] && ratingIsEnabled) {
      getRatingBySku(sku)
    }
  }, [ratingList, ratingIsEnabled, sku]);

  useEffect(() => {
    if (Cart.error)
      notification.error({ message: 'Não foi possível adicionar o produto informado ao carrinho!' });
  }, [Cart.error]);

  useEffect(() => {
    if (productRelatedDetailsId) {
      setIsOpenInfoRelatedModal(!isOpenInfoRelatedModal)
    }
  }, [productRelatedDetailsId]);

  /* Renders */

  useEffect(() => {
    if (availabilityBySku && product) {
      eventGa("view_item", {
        currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
        value: parseFloat(availabilityBySku?.price?.price || 0),
        items: [
          {
            item_id: sku,
            item_name: product.name,
            currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
            item_brand: product.vendor.name,
            price: parseFloat(availabilityBySku?.price?.price || 0),
            quantity: 1
          }
        ]
      })
    }
  }, [availabilityBySku, product, sku, Catalog]);

  return (
    <CepProvider>
      <PipeProvider
        apiSymbols={[
          {
            symbol: 'FETCH_STORES',
            alias: null,
            payload: {
              catalogId: userProfile['custom:catalog_id']
            },
          }
        ]}
        loadingComponent={
          <div className="header-profile-name">
            <VertSkeleton paragraph={{ rows: 1 }} active title={false} />
          </div>
        }
      >
        <VertContainer spacingX="regular" className="pdp-wrapper">
          <ProductHeader
            sku={sku}
            title={product?.name || ''}
            seller={product?.vendor?.name || ''}
            rate={rating.store}
            favorited={isProductInWishList}
            toogleWishList={handleToggleWishList}
            hasAboutProduct={productAboutItems.length > 0}
            refAboutProduct={refAboutProduct}
            discountRate={availabilityBySku?.price?.discountRate || 0}
            categoryHierarchy={product?.subcategory}
          />

          <div className="pdp-content">

            {
              skuSelectedDetails && skuSelectedDetails.images && (<>
                <ProductImage images={skuSelectedDetails.images} />
              </>)
            }
            <ProductDetailBlock
              productInfo={product}
              skus={product?.skus}
              hasInventory={verifyHasInventory?.hasInventory}
              inventoryQuantity={verifyHasInventory?.inventoryQuantity}
              pointValue={
                availabilityBySku?.price?.price ||
                availabilityBySku?.price?.regularPrice ||
                0
              }
              vendor={product?.vendor}
              regularPointsValue={availabilityBySku?.price?.regularPrice || 0}
              colorOptions={skuSelectedDetails?.skuFeatures
                ?.filter((item) => item.type === 'COR')
                .map((item) => ({
                  label: item.value,
                  value: item.value,
                  availability: true,
                }))}
              sizeOptions={skuSelectedDetails?.skuFeatures
                ?.filter((item) => item.type === 'TAMANHO')
                .map((item) => ({
                  label: item.value,
                  value: item.value,
                  availability: true,
                }))}
              voltageOptions={skuSelectedDetails?.skuFeatures
                ?.filter((item) => item.type === 'VOLTAGEM')
                .map((item) => ({
                  label: item.value,
                  value: item.value,
                  availability: true,
                }))}
              rate={ratingList ? ratingList[sku] : null}
              openModalHandler={infoModalHandler}
              addToCart={handleAddToCart}
              isAvailable={(typeof availabilityBySku?.isAvailable === 'boolean') ? availabilityBySku?.isAvailable : null}
              isAvailableForParticipant={availabilityBySku?.isAvailableForParticipant}
              redemptionsCount={availabilityBySku?.redemptionsCount}
              remainingRedemptions={availabilityBySku?.remainingRedemptions}
              nextAvailableDate={availabilityBySku?.nextAvailableDate}
              minimumPurchase={skuSelectedDetails?.minimumPurchase || 1}
              isQuoteItem={product?.type == 3}
              quotationModalHandler={handleQuotationModal}
              selectedVendor={productRelatedSelected}
              clearSelectedVendor={handleClearSelectedVendor}
              productHaveRelatedItems={productHaveRelatedItems}
            />
          </div>
          {
            !dataProductRelated.isLoadingRelated &&
            dataProductRelated.isSuccessRelated &&
            relatedProducts.length > 0 && (
              <>
                <div className="related-container">

                  <div className='container-related-products'>

                    <ColAntd span={24}>
                      <MediaQuery maxWidth={768}>
                        <VertTypography.Title level={2} className="margin-bottom-none">Selecione o fornecedor</VertTypography.Title>
                      </MediaQuery>
                      <MediaQuery minWidth={769}>
                        <VertTypography.Title level={2} className="margin-bottom-none">Selecione o fornecedor</VertTypography.Title>
                      </MediaQuery>
                    </ColAntd>

                    <Row gutter={[8, 8]} className='container-related-products-iteration'>

                      {relatedProducts?.map((item) => (
                        <ColAntd>
                          <RelatedProductsCard
                            item={item}
                            checked={item.marketplaceSku == sku}
                            setInfoDataModal={handleProductDetail}
                            setChecked={
                              (productRelatedInfo) => {
                                setProductAboutItems([]);                                
                                navigate(`/product/${productRelatedInfo.marketplaceSku}`);
                              }
                            }
                          />
                        </ColAntd>
                      ))}

                    </Row>

                  </div>

                </div>
              </>
            )}
          {productAboutItems.length > 0 && (
            <div ref={refAboutProduct}>
              <VertTypography.Title className="redemption-label">
                Sobre o produto
              </VertTypography.Title>
              <VertCollapse items={productAboutItems} defaultActiveKey='location' />
            </div>
          )}
        </VertContainer>

        <ShowCaseAutomate
          idDisplayAreaId={ShowcaseDisplayAreaEnum.PRODUCT_PAGE}
        />

        <VertModal
          open={isOpenInfoModal}
          className="redemption-options-modal"
          onCancel={infoModalHandler}
          title={<h1>Pontos + dinheiro</h1>}
          template="marketplace"
          spacing="regular"
        >
          <div className="redemption-options-content">
            <VertTypography.Paragraph>
              Não tem pontos suficientes para fazer o resgate? Sem problemas!
            </VertTypography.Paragraph>

            <VertTypography.Paragraph>
              Você pode pagar sua compra com os pontos que tem e completar o
              valor usando seu cartão de crédito.
            </VertTypography.Paragraph>

            <VertTypography.Paragraph className="label">
              Veja essas sugestões para você resgatar:
            </VertTypography.Paragraph>

            <Col>
              <div className="points-plus-cash-items">
                {pointsPlusCashBySku?.items
                  ?.filter((item) => item.installmentValue > 0)
                  .map((item) => (
                    <VertTypography.Paragraph key={item.installment}>
                      {`${item.totalPoints} pontos + R$ ${formatReal(
                        item.totalCash
                      )} em ${item.totalInstallments} vez de R$ ${formatReal(
                        item.installmentValue
                      )}`}
                    </VertTypography.Paragraph>
                  ))}
              </div>
              <VertTypography.Paragraph>
                Na etapa de pagamento, você poderá definir outras combinações
                entre pontos e cartão de crédito.
              </VertTypography.Paragraph>
            </Col>

            <div className="divider" />

            <div className="cards-accepted">
              <VertTypography.Paragraph className="label">
                Bandeiras aceitas
              </VertTypography.Paragraph>

              <div className="cards-images">
                {productPageMocks.cardsAccepted.map((item) => (
                  <img src={item.url} alt={item.alt} key={generateUUID()} />
                ))}
              </div>
            </div>

            <div className="divider" />

            <VertTypography.Paragraph className="label">
              Parcelamento
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              Em até 3 vezes sem juros.
            </VertTypography.Paragraph>
          </div>
        </VertModal>

        <VertModal
          open={isOpenInfoRelatedModal}
          className="info-options-modal"
          onCancel={() => {
            setIsOpenInfoRelatedModal(false);
            setProductRelatedDetailsId("");
          }}
          title={<h1>Sobre o produto</h1>}
          template="marketplace"
          spacing="regular"
        >
          <ModalRelatedProductDetails sku={productRelatedDetailsId} />
        </VertModal>

        <VertModal
          open={isOpenQuotationModal}
          className="quotation-options-modal"
          onCancel={() => handleQuotationModal(false)}
          title={<h1>Cotação de Produto</h1>}
          template="marketplace"
          spacing="regular"
          centered
        >
          {
            product?.formId == QUOTATION_FORM_TYPE.NORMAL_QUOTATION && (
              <DefaultQuotationFormModal
                product={product}
                sku={originalId}
                onRequestSuccess={() => setIsOpenQuotationModal(false)}
              />
            )
          }

          {
            product?.formId == QUOTATION_FORM_TYPE.SYNGENTA_QUOTATION && (
              <div className="quotation-options-content">
                <SyngentaQuotationFormModal
                  product={productRelatedSelected ? productRelatedSelected?.name : product?.name}
                  vendorId={productRelatedSelected ? productRelatedSelected?.vendor?.id : product?.vendor?.id}
                  sku={productRelatedSelected ? productRelatedSelected?.sku : sku}
                  originalId={skuSelectedDetails?.originalId}
                  detail={null}
                  onRequestClose={null}
                  loading={null}
                  setLoading={null}
                  onRequestSuccess={handleQuotationModal}
                  isOpen={isOpenQuotationModal}
                />
              </div>
            )
          }

          {
            product?.formId == QUOTATION_FORM_TYPE.AGRO_INSURANCE_QUOTATION && (
              <AgroInsuranceQuotationFormModal
                product={product?.name}
                vendorId={product?.vendor?.id}
                sku={originalId}
                setIsModalOpened={setIsOpenQuotationModal}
              />
            )
          }
        </VertModal>
      </PipeProvider>
    </CepProvider >
  );
};

export default ProductPage;
